module.exports = __webpack_public_path__ + "build/img/tan_s.a446d088.png";